import { eTaxAuthorityType } from '../../../ui-toolkit/enums/eTaxAuthorityType';

export default function generateTaxAuthorityTypeOptions() {
  return Object.entries({
    /*tslint:disable:object-literal-sort-keys*/
    State: eTaxAuthorityType.state,
    County: eTaxAuthorityType.county,
    City: eTaxAuthorityType.city,
    Local: eTaxAuthorityType,
    /*tslint:enable:object-literal-sort-keys*/
  }).map((entry) => ({ label: entry[0], value: entry[1] }));
}
